<template>
    <div class="leads-table">
        <table class="content-left large" v-if="leads.length">
            <tr>
                <th>file name</th>
                <th>date of upload</th>
                <th>leads enriched</th>
                <th>credits used</th>
                <th></th>
                <th></th>
            </tr>
            <tr class="card-content" v-for="lead in leads" v-bind:key='lead.id'>
                <td class="border-l"> {{lead.file_name}} </td>
                <td> {{lead.date_upload}}</td>
                <td> {{lead.leads_enriched}} </td>
                <td> {{lead.credits_used}} </td>
                <td class="border-r">
                    <div class="my-btn">
                        <div class="btn-text" @click="downloadCsv(lead)">
                            Download
                        </div>
                        <i class="far fa-arrow-alt-circle-down"></i>
                    </div>
                </td>
                <td class="border-r">
                    <div class="my-btn">
                        <router-link class="btn-text-details" :to="`/csv/${lead.id}`">
                            View details
                        </router-link>
                    </div>
                </td>
            </tr>
        </table>
        <infinite-loading @infinite="previousLeads">
            <div slot="no-more"></div>
            <div slot="no-results"></div>
        </infinite-loading>
    </div>
</template>

<script>

import { mapMutations } from 'vuex'

export default {
  name: 'previousCharge',
  data () {
    return {
      count: 0,
      start: 5
    }
  },
  methods: {
    ...mapMutations([
      'user/setCredits',
      'uploadedLeadList/setLeads'
    ]),
    downloadCsv (data) {
      var filename = 'data_enriched_' + data.id + '.csv'
      var tempLink = document.createElement('a')
      tempLink.href = data.s3_url.replace('http://', 'https://')
      tempLink.setAttribute('download', filename)
      tempLink.click()
    },
    previousLeads ($state) {
      this.$http.get('/api/leads/all_leads/' + this.start).then((res) => {
        this['uploadedLeadList/setLeads'](res.data.leads)
        this['user/setCredits'](res.data.user_credits)
        this.count = res.data.len
        this.start = this.start + 5
        $state.loaded()
        if (res.data.leads.length === res.data.len) {
          $state.complete()
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  computed: {
    leads: function () {
      return this.$store.state.uploadedLeadList.leads
    }
  }
}

</script>

<style lang="scss">

@media only screen and (max-width: 600px) {
  .leads-table {
    overflow: auto;
  }
}

.leads-table {
    margin-top: 50px;
}

table{
    margin-top: 20px;
    border-collapse: separate;
    border-spacing: 0 20px;
    tr {
        td {
            padding: 10px;
        }
        .border-l {
            border-radius: 5px 0px 0px 5px;
        }
        .border-r {
            border-radius: 0px 5px 5px 0px;
            text-align: right;
        }
    }
}

</style>
